<template>
  <div class="upload">
    <div class="title">
      <h3>
        <i class="el-icon-arrow-left"></i> 上传资料
        <span>带<i>*</i>为必填项</span>
      </h3>
    </div>
    <div class="formdata">
        <el-form ref="form" :model="sizeForm" label-width="200px" size="mini">
        <el-form-item label="语言:" :required="true">
              <el-radio v-model="sizeForm.radio" label="1">中文</el-radio>
            <el-radio v-model="sizeForm.radio" label="2">英文</el-radio>
        </el-form-item>
        <el-form-item label="资料名称:" :required="true">
             <el-input
            v-model="sizeForm.dataName"
            placeholder="请输入资料名称"
          ></el-input>
        </el-form-item>
            <el-form-item label="资料文件:" :required="true">
             <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-change="handleChange"
                :file-list="fileList"
              >
                <el-button size="small" class="select" type="primary"
                  >点击上传</el-button
                >
              </el-upload>

        </el-form-item>
         <el-button type="primary" class="button" @click="submitForm('sizeForm')"
          >提交</el-button
        >
        </el-form>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        sizeForm:{
            radio:'',
            dataName:''
        },
        fileList:[]
    };
  },
  create() {},
  methods: {
        submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
      handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },


  },
};
</script>
<style lang="scss" scoped>
.upload {
  margin: 17px 26px 20px 26px;
  box-sizing: border-box;
  padding: 18px 26px 0 0;
  background: white;
  height: 785px;
  .title {
    height: 55px;
    padding-left: 26px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 35px;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
    button {
      width: 88px;
      height: 32px;
      border: 1px solid #006fb8;
      color: #006fb8;
      background: white;
      margin-left: 10px;
    }
  }
  .formdata{
      width: 560px;
      margin: 0 auto;
     .select {
      display: block;
      font-style: normal;
      width: 95px;
      height: 28px;
      background: #ffffff;
      color: #666;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
    }
       .button {
        width: 77px;
        height: 28px;
        line-height: 5px;
      margin-left:200px;
      background: #006fb8;
      opacity: 0.5;
    }
  }
}
</style>